module.exports = __webpack_public_path__ + "img/edit.75526210.svg";